import React, { useMemo } from 'react';
import { PriceChange } from '../../types';
import { calculatePriceChangeStats } from '../../utils/priceChangeUtils';
import StatCards from './components/StatCards/StatCards';
import Charts from './components/Charts/Charts';
import TopChangesTable from './components/TopChangesTable/TopChangesTable';
import './Stats.scss';

interface StatsProps {
  data: PriceChange[];
  startDate: string;
  endDate: string;
}

const PriceChangeStats: React.FC<StatsProps> = ({ data, startDate, endDate }) => {
  const stats = useMemo(() => calculatePriceChangeStats(data), [data]);

  if (data.length === 0) {
    return (
      <div className="price-changes-stats-container">
        <div className="stats-empty">
          <div className="empty-icon">📊</div>
          <h4>No hay datos disponibles</h4>
          <p>No se encontraron cambios de precios para el período seleccionado</p>
        </div>
      </div>
    );
  }

  return (
    <div className="price-changes-stats-container">
      {/* Summary Cards */}
      <section className="stats-section">
        <StatCards stats={stats} />
      </section>

      {/* Charts Section */}
      <section className="stats-section">
        <Charts data={data} />
      </section>

      {/* Top Changes Tables */}
      <section className="stats-section">
        <TopChangesTable data={data} />
      </section>
    </div>
  );
};

export default PriceChangeStats;
